"use client";

import AuthView from "@/views/Auth";

export default function AuthPage() {
  return <AuthView />;
}
